import React from 'react';
import { Headline, Paragraph, RoundedBox, Image } from 'View/Common';
import { Section } from 'View/Container';
import { quote_svg, stars_svg } from 'img/SleepPage';
import TestimonialsStyle from './Testimonials.style';
import { TestimonialsContent } from './TestimonialsContent';
import { ITestimonialSliderSettings, useTestimonialSliderSettings } from 'View/HookApi/useTestimonialSliderSettings';
import { Slider } from 'View/Component';

export const Testimonials: React.FC = () => {
  const settings: ITestimonialSliderSettings = useTestimonialSliderSettings(TestimonialsContent.length);

  return (
    <TestimonialsStyle>
      <Section className="slider-testimonials">
        <Headline level={2} className="text-center">
          Nutzende, die mit 7Schläfer schlafen
        </Headline>

        <Slider settings={settings}>
          {TestimonialsContent.map((testimonial) => (
            <div key={testimonial.id}>
              <RoundedBox className="quote-box">
                <Image image={quote_svg} className="quote-img" height={40} width={40} alt="Anführungszeichen Icon" />
                <Paragraph className="small">{testimonial.text}</Paragraph>
                <Image image={stars_svg} className="stars-img" height={24} width={120} alt="5 Sterne Bewertung" />
                <Paragraph>{testimonial.name}</Paragraph>
              </RoundedBox>
            </div>
          ))}
        </Slider>
      </Section>
    </TestimonialsStyle>
  );
};
